import { render, staticRenderFns } from "./DataTableOrder.vue?vue&type=template&id=0fecf8f3&scoped=true"
import script from "./DataTableOrder.vue?vue&type=script&lang=js"
export * from "./DataTableOrder.vue?vue&type=script&lang=js"
import style0 from "./DataTableOrder.vue?vue&type=style&index=0&id=0fecf8f3&prod&lang=scss"
import style1 from "./DataTableOrder.vue?vue&type=style&index=1&id=0fecf8f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fecf8f3",
  null
  
)

export default component.exports